import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Alert Banner Component
 * Displays a gradient banner with title, message, and action buttons
 */
const AlertBanner = ({ title, message, children }) => {
  return (
    <Box
      sx={{
        width: '100vw',
        background: 'linear-gradient(135deg,rgb(83, 101, 138) 0%,rgb(46, 112, 204) 100%)',
        py: 2,
        px: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around',
        gap: 5,
        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          pointerEvents: 'none'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, color: 'white', zIndex: 1 }}>
        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </Box>

      <Typography variant="body1" sx={{ color: 'white', textAlign: 'center', maxWidth: '800px', zIndex: 1 }}>
        {message}
      </Typography>

      {children && (
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center', zIndex: 1 }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default AlertBanner;